export default __webpack_public_path__ + "static/beneficios-estado-e8e7376f98f920c3d66f472f94c6ccdf.png";